import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  slug: string;
  cover: string;
  author: string;
  category: string;
  status: string;
  latestChapter: string;
  rating: number;
  views: number;
  shortDescription: string;
}

export default function ComicCard({
  id,
  title,
  slug,
  cover,
  author,
  status,
  latestChapter,
  rating,
  views,
  shortDescription,
}: ComicCardProps) {
  const formattedViews = views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toString();

  return (
    <Link
      to={`/article/${id}/${slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 虫虫动漫免费漫画`}
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 text-xs rounded-full ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <p className="text-background-50 text-xs truncate">{latestChapter}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <p className="text-xs text-foreground-400 mt-0.5 line-clamp-2 leading-relaxed">
          {shortDescription}
        </p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span className="text-xs text-accent-600 font-medium">{rating}</span>
          </div>
          <span className="text-xs text-foreground-400">{formattedViews} 阅读</span>
        </div>
      </div>
    </Link>
  );
}